/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconProtocol = createReactComponent("protocol", "IconProtocol", [
  ["path", { d: "M15 6l-7 12", key: "svg-0" }],
  ["path", { d: "M20 6l-7 12", key: "svg-1" }],
  ["path", { d: "M5 14v.015", key: "svg-2" }],
  ["path", { d: "M5 10.015v.015", key: "svg-3" }]
]);

export { IconProtocol as default };
//# sourceMappingURL=IconProtocol.js.map
